module.exports = __webpack_public_path__ + "assets/img/cy-select.106fe7a2.png";